export default function isValueNullOrNegative(value) {
	return value === null || value < 0;
}
